import RequestInfo from './RequestInfo';

export default RequestInfo;
